import React from "react";
import { TextInput } from "colbi_web_ui/lib/components/inputs";
import { SovosIcon } from "mosaic-react";
import { HighlightOff } from "mosaic-react-icons";
import styles from "./MetadataEntry.module.sass";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const MetadataContainer = ({ onChange, metadataKeys, metadataValues }) => {
    const { i18n } = useGlobalValue();

    const handleInputChange = (e, inputName, index) => {
        onChange(index, e, inputName);
    };

    const handleRemoveClick = (index) => {
        onChange(index, null);
    };

    return (
        <div>
            <div className={`${styles["metadata-entry"]} ${styles["scrollable-metadata-entry"]}`}>
                {(metadataKeys || []).map((metadataKey, index) => {
                    return (
                        <div
                            key={index}
                            className={`${styles["metadata-container"]} ${styles["darker-border"]}`}
                        >
                            <div
                                className={`${styles["remove-button-container"]} ${styles["flex-end"]}`}
                            >
                                <button
                                    type="button"
                                    className={styles["remove-button"]}
                                    onClick={(e) => {
                                        handleRemoveClick(index);
                                    }}
                                >
                                    <SovosIcon>
                                        <HighlightOff />
                                    </SovosIcon>
                                </button>
                            </div>
                            <div className={styles["flex"]}>
                                <div className={styles["input-field"]}>
                                    <TextInput
                                        className={styles["input"]}
                                        name={i18n`Column`}
                                        placeholder={i18n`Enter a column description`}
                                        value={metadataKey || ""}
                                        onChange={(e) => {
                                            handleInputChange(e.target.value, "keyArray", index);
                                        }}
                                    />
                                </div>
                                <div className={styles["input-field"]}>
                                    <TextInput
                                        className={styles["input"]}
                                        name={i18n`Value`}
                                        placeholder={i18n`Enter a value description`}
                                        value={metadataValues[index] || ""}
                                        onChange={(e) => {
                                            handleInputChange(e.target.value, "valueArray", index);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MetadataContainer;
